import {Component, EventEmitter, Input, Output} from '@angular/core';
import {AuthService} from 'src/app/identity/auth.service';

@Component({
    selector: 'app-no-results',
    templateUrl: './no-results.component.html',
    styleUrls: ['./no-results.component.scss'],
    standalone: false
})
export class NoResultsComponent {
    @Input() unsavedQuery: boolean;
    @Input() isSaving = false;
    @Output() saveQuery = new EventEmitter();

    constructor(public auth: AuthService) {
    }

    save(): void {
        this.saveQuery.emit();
    }
}
